export default __webpack_public_path__ + "static/media/search.ea74efe6.png";